<template>
    <div>
        <FormControl
            label="Type"
            required
        >
            <div class="space-y-1">
                <RadioInput
                    label="Single line"
                    :value="CustomFieldTextTypeEnum.SingleLine"
                    :checked="
                        localSettings?.data?.textType ===
                        CustomFieldTextTypeEnum.SingleLine
                    "
                    :name="`${RequestBodyKeyEnum.App_UpdateService_CustomFields_Settings}[${CustomFieldTypeEnum.Text}][${CustomFieldSettingsKeysEnum.Text_Type}]`"
                    required
                />
                <RadioInput
                    label="Multi line"
                    :value="CustomFieldTextTypeEnum.MultiLine"
                    :checked="
                        localSettings?.data?.textType ===
                        CustomFieldTextTypeEnum.MultiLine
                    "
                    :name="`${RequestBodyKeyEnum.App_UpdateService_CustomFields_Settings}[${CustomFieldTypeEnum.Text}][${CustomFieldSettingsKeysEnum.Text_Type}]`"
                    required
                />
            </div>
        </FormControl>
        <FormControl label="Placeholder text">
            <TextInput
                :value="localSettings?.data?.textPlaceholderText"
                :name="`${RequestBodyKeyEnum.App_UpdateService_CustomFields_Settings}[${CustomFieldTypeEnum.Text}][${CustomFieldSettingsKeysEnum.Text_PlaceholderText}]`"
            />
        </FormControl>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import CustomField from '@/App/CustomField/Entity/CustomField'
    import {
        CustomFieldSettingsKeysEnum,
        CustomFieldTextTypeEnum,
        CustomFieldTypeEnum,
        type CustomFieldSettingsTextType,
    } from '@/Shared/AutoGenerated/Main'
    import RadioInput from '@/Shared/Component/Forms/RadioInput.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        customField: {
            type: Object as PropType<CustomField | null>,
            default: null,
        },
    })

    const localSettings: CustomFieldSettingsTextType | null =
        props.customField?.settings
</script>
